export { QueryProvider } from './QueryProvider';
export {
  useCustomQuery,
  useCustomInfiniteQuery,
  registerGlobalQueryMiddleware,
  clearGlobalQueryMiddleware,
  registerGlobalInfiniteQueryMiddleware,
  clearGlobalInfiniteQueryMiddleware,
  type QueryMiddleware,
  type InfiniteQueryMiddleware,
} from './useCustomQuery';
